import { FormFieldBase } from './form-field-base';

export class DropdownMultipleField extends FormFieldBase<string> {
  override controlType = 'dropdown-multiple';
  options: { key: string, value: string }[] = [];

  constructor(options: {} = {}) {
    super(options);
    if (options['options']) {
      this.options = (options['options'] as { key: string, value: string }[]).map(option => {
        let cleanValue = option.value;
        if (cleanValue.endsWith(',')) {
          cleanValue = cleanValue.slice(0, -1);
        }
        return { ...option, value: cleanValue };
      });
    } else {
      this.options = [];
    }
  }
}
